import { useMemo } from 'react';
import { CategoryData } from '../util/tileEnums';
import { isOldEnoughToCreateAccount } from '../../../../../core/util/account';

export default (category: any, birthDate: any) => {
  return useMemo(() => {
    return isOldEnoughToCreateAccount(birthDate);
  }, [birthDate]);
};
